import axios from 'axios';

const baseUrl = (import.meta as any).env.VITE_BASE_URL_API;
const instanceAxios = axios.create({
  baseURL: `${baseUrl.includes('localhost') ? 'http' : 'https'}://${baseUrl}/api/`
});

instanceAxios.interceptors.request.use(config => {
  const token = localStorage.getItem('reshet-token');
  if (token) {
    config!.headers!.Authorization = token;
  }
  return config;
});

instanceAxios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.log(error);
    if (error.response.status === 401) {
      window.localStorage.removeItem('reshet-token');
      const pathName = window.location.pathname;
      if (pathName !== '/login' && pathName !== '/' && pathName !== '/login-mfa' && !pathName.includes('upload-reference') ) {
        window.localStorage.setItem('redirect', pathName);
        window.location.replace('/login');
      }
    }
    throw error;
  }
);

export default instanceAxios;
